import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c78649a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, "舟山海星轮船有限公司"),
    /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "ZHOUSHAN HAIXING SHIPPING CN")
  ])
], -1))
const _hoisted_4 = { class: "header-bottom" }

import TabBar from '@/views/header/cpns/tab-bar/index.vue'
import Tips from './cpns/tips/index.vue'
import { LOGIN_TOKEN } from '@/global/constants'
import { localCache } from '@/utils/cache'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'


const __default__ = { name: 'headerView' }

export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

const route = useRoute()
const localCacheToken = ref()
localCacheToken.value = localCache.getCache(LOGIN_TOKEN)
const handleQuit = () => {
  localCacheToken.value = localCache.getCache(LOGIN_TOKEN)
}
watch(
  () => route.params,
  () => {
    localCacheToken.value = localCache.getCache(LOGIN_TOKEN)
  },
  { immediate: true }
)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (localCacheToken.value)
        ? (_openBlock(), _createBlock(TabBar, {
            key: 0,
            onQuit: handleQuit
          }))
        : _createCommentVNode("", true)
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Tips)
    ])
  ]))
}
}

})